/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_Auth_DescInputs */

const en_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create an account or sign in to reserve your spot.`)
};

const es_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea una cuenta o inicia sesión para reservar tu lugar.`)
};

const de_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstellen Sie ein Konto oder melden Sie sich an, um Ihren Platz zu reservieren.`)
};

const zh_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建帐户或登录以保留你的位置。`)
};

const ar_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أنشئ حساباً أو سجّل الدخول لحجز مقعدك.`)
};

const fr_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créez un compte ou connectez-vous pour réserver votre place.`)
};

const vi_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo tài khoản hoặc đăng nhập để giữ chỗ của bạn.`)
};

const sw_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fungua akaunti au ingia ili kuweka nafasi yako.`)
};

const th_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างบัญชีหรือลงชื่อเข้าใช้เพื่อสำรองที่นั่งของคุณ`)
};

const bs_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kreirajte račun ili se prijavite da rezervišete mjesto.`)
};

const ja_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アカウントを作成するか、ログインして参加枠を予約してください。`)
};

const ko_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`계정을 만들거나 로그인하여 자리를 예약하십시오.`)
};

const pt_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crie uma conta ou entre para garantir sua vaga.`)
};

const it_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea un account o accedi per prenotare il tuo posto.`)
};

const sv_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapa ett konto eller logga in för att reservera din plats.`)
};

const nl_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak een account aan of meld je aan om je plek te reserveren.`)
};

const da_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opret en konto eller log ind for at reservere din plads.`)
};

const nb_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opprett en konto eller logg på for å reservere plassen din.`)
};

const fi_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo tili tai kirjaudu sisään varataksesi paikkasi.`)
};

const pl_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz konto lub zaloguj się, aby zarezerwować miejsce.`)
};

const ru_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создайте учетную запись или войдите, чтобы забронировать место.`)
};

const tr_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yerinizi ayırtmak için bir hesap oluşturun veya giriş yapın.`)
};

const hi_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपने स्थान को आरक्षित करने के लिए एक खाता बनाएं या साइन इन करें।`)
};

const id_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buat akun atau masuk untuk memesan tempat Anda.`)
};

const ms_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cipta akaun atau log masuk untuk menempah tempat anda.`)
};

const cs_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořte si účet nebo se přihlaste a zarezervujte si místo.`)
};

const el_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δημιουργήστε λογαριασμό ή συνδεθείτε για να κάνετε κράτηση.`)
};

const he_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צרו חשבון או היכנסו כדי לשמור את המקום שלכם.`)
};

const af_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skep 'n rekening of meld aan om jou plek te bespreek.`)
};

const hu_events_auth_desc = /** @type {(inputs: Events_Auth_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hozz létre egy fiókot, vagy jelentkezz be, hogy lefoglald a helyed.`)
};

/**
* | output |
* | --- |
* | "Create an account or sign in to reserve your spot." |
*
* @param {Events_Auth_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const events_auth_desc = /** @type {((inputs?: Events_Auth_DescInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_Auth_DescInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_events_auth_desc(inputs)
	if (locale === "de") return de_events_auth_desc(inputs)
	if (locale === "zh") return zh_events_auth_desc(inputs)
	if (locale === "ar") return ar_events_auth_desc(inputs)
	if (locale === "fr") return fr_events_auth_desc(inputs)
	if (locale === "vi") return vi_events_auth_desc(inputs)
	if (locale === "sw") return sw_events_auth_desc(inputs)
	if (locale === "th") return th_events_auth_desc(inputs)
	if (locale === "bs") return bs_events_auth_desc(inputs)
	if (locale === "ja") return ja_events_auth_desc(inputs)
	if (locale === "ko") return ko_events_auth_desc(inputs)
	if (locale === "pt") return pt_events_auth_desc(inputs)
	if (locale === "it") return it_events_auth_desc(inputs)
	if (locale === "sv") return sv_events_auth_desc(inputs)
	if (locale === "nl") return nl_events_auth_desc(inputs)
	if (locale === "da") return da_events_auth_desc(inputs)
	if (locale === "nb") return nb_events_auth_desc(inputs)
	if (locale === "fi") return fi_events_auth_desc(inputs)
	if (locale === "pl") return pl_events_auth_desc(inputs)
	if (locale === "ru") return ru_events_auth_desc(inputs)
	if (locale === "tr") return tr_events_auth_desc(inputs)
	if (locale === "hi") return hi_events_auth_desc(inputs)
	if (locale === "id") return id_events_auth_desc(inputs)
	if (locale === "ms") return ms_events_auth_desc(inputs)
	if (locale === "cs") return cs_events_auth_desc(inputs)
	if (locale === "el") return el_events_auth_desc(inputs)
	if (locale === "he") return he_events_auth_desc(inputs)
	if (locale === "af") return af_events_auth_desc(inputs)
	if (locale === "hu") return hu_events_auth_desc(inputs)
	return en_events_auth_desc(inputs)
});